import { setTerm } from './helpers';

export const setHasVideo = setTerm('has_video');
